module.exports = __webpack_public_path__ + "static/afa-94c421877fba97f554af554b74712c0e.png";